// extracted by mini-css-extract-plugin
export default {"infoblock":"infoblock_infoblock__hPXgI","content":"infoblock_content__m347s"};